import { useBrandAccountSurveyGroupsQuery } from './useBrandAccountSurveyGroupsQuery'

export const useBrandAccountSurveyGroupsQueryData = (
  brandAccountId: string | undefined,
) => {
  const result = useBrandAccountSurveyGroupsQuery(brandAccountId)

  return result.data ?? []
}
